import React from 'react'
import formatMessage from 'format-message'
import { FRIENDLY_COLORS } from '../constants'

const annotationTypeLabels = {
  freetext: formatMessage('free text'),
  highlight: formatMessage('highlight'),
  ink: formatMessage('drawing'),
  square: formatMessage('area'),
  strikeout: formatMessage('strikeout'),
  text: formatMessage('point'),
}

function isSaved(annotation) {
  return annotation.created_at
}

function notAReply(annotation) {
  return !annotation.inreplyto
}

function isAReply(annotation) {
  return annotation.inreplyto
}

function friendlyColor(color) {
  return FRIENDLY_COLORS[color] ? formatMessage(FRIENDLY_COLORS[color]) : undefined
}

function generateRemovedMessage(annotation) {
  if (annotation.deleted_at && annotation.deleted_by) {
    return formatMessage('Removed {d,date} by {name}', {
      d: new Date(annotation.deleted_at),
      name: annotation.deleted_by,
    })
  } else if (annotation.deleted_by) {
    return formatMessage('Removed by {name}', {
      name: annotation.deleted_by,
    })
  } else if (annotation.deleted_at) {
    return formatMessage('Removed {d,date}', {
      d: new Date(annotation.deleted_at),
    })
  } else {
    return formatMessage('Removed')
  }
}

export default function ScreenreaderAnnotations({ annotationsByPage }) {
  const pages = Object.keys(annotationsByPage).map((pageNumber) => {
    const annotations = annotationsByPage[pageNumber]
      .filter(isSaved)
      .filter(notAReply)
      .map((annotation) => {
        const color = friendlyColor(annotation.color)
        const replies = annotationsByPage[pageNumber]
          .filter(isSaved)
          .filter(isAReply)
          .filter((reply) => annotation.id === reply.inreplyto)
          .map((reply) => {
            return (
              <li key={reply.id}>
                {reply.deleted && (
                  <div className="ScreenreaderAnnotation-deleted">
                    {generateRemovedMessage(reply)}
                  </div>
                )}
                <div className="ScreenreaderAnnotation-author">
                  {formatMessage('Author')} :{reply.user_name}
                </div>
                <div className="ScreenreaderAnnotation-createdat">
                  {formatMessage('Created at { createdAt, time, short }', {
                    createdAt: new Date(reply.created_at),
                  })}
                </div>
                {reply.contents && (
                  <div className="ScreenreaderAnnotation-root-comment">
                    {formatMessage('Comment Reply')} :{reply.contents}
                  </div>
                )}
              </li>
            )
          })
        return (
          <li key={annotation.id} className="ScreenreaderAnnotation">
            <h4>
              {formatMessage('Annotation of type { type }', {
                type: annotationTypeLabels[annotation.type] || annotation.type,
              })}
            </h4>
            {annotation.deleted && (
              <div className="ScreenreaderAnnotation-deleted">
                {generateRemovedMessage(annotation)}
              </div>
            )}
            <div className="ScreenreaderAnnotation-author">
              {formatMessage('Author')} :{annotation.user_name}
            </div>
            {color && (
              <div className="ScreenreaderAnnotation-color">
                {formatMessage('Color')} :{color}
              </div>
            )}
            <div className="ScreenreaderAnnotation-createdat">
              {formatMessage('Created at { createdAt, time, short }', {
                createdAt: new Date(annotation.created_at),
              })}
            </div>

            {annotation.contents && (
              <div className="ScreenreaderAnnotation-root-comment">
                {formatMessage('Comment')} :{annotation.contents}
              </div>
            )}
            {Boolean(replies.length) && (
              <div className="ScreenreaderAnnotation-replies">
                <h5>{formatMessage('Replies')}</h5>
                <ol>{replies}</ol>
              </div>
            )}
          </li>
        )
      })
    return (
      <div key={pageNumber} className="ScreenreaderAnnotations-page">
        <h3>
          {formatMessage('Page { pageNumber, number }', {
            pageNumber: parseInt(pageNumber, 10) + 1, // 0-based to 1-based
          })}
        </h3>
        <ol>{annotations}</ol>
      </div>
    )
  })
  return (
    <div className="ScreenreaderAnnotations screenreader-only">
      <h2>{formatMessage('Annotations')}</h2>
      {pages}
    </div>
  )
}
